module.exports = __webpack_public_path__ + "static/LucasPope0-94c001e1e67f58e1b15739f60aa803cf.png";